import React from 'react'
import { Route, Routes, BrowserRouter} from 'react-router-dom';
import './App.css';
import RequireAuth from './contexts/RequireAuth';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Sales from './pages/Sales';
import DailyExpense from './pages/DailyExpense';
import Purchase from './pages/Purchase';
import StockProduction from './pages/StockProduction';
import MarketDue from './pages/MarketDue';
import StockMaterials from './pages/StockMaterials';
import Settings from './pages/Settings';
import Attendance from './pages/Attendance';
import Home from './pages/Home';

function App() {
  return (
    <div>
        <BrowserRouter>
            <Routes>
                {/* Public Routes */}
                <Route path='/login' element={<Login />}  />
                <Route path = '/forgot-password' element={<ForgotPassword />} />
                <Route path = '/reset-password' element={<ResetPassword />} />
                {/* Protected Routes */}
                <Route element={<RequireAuth />}>
                    <Route path='' element={<Home />} />
                    <Route path='/sales' element={<Sales />} />
                    <Route path='/market-due' element={<MarketDue />} />
                    <Route path='/daily-expense' element={<DailyExpense />} />
                    <Route path='/purchase' element={<Purchase />} />
                    <Route path='/stock-production' element={<StockProduction />} />
                    <Route path='/stock-materials' element={<StockMaterials />} />
                    <Route path='/attendance' element={<Attendance />} />
                    <Route path='/settings' element={<Settings />} />
                </Route>
            </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
